import { Col, Form, Row } from "react-bootstrap";
import { GEOGRAPHY_TYPE_OPTIONS } from "./regDataAlignmentDisplay";

export interface GeographyRegDataComparisonRowProps {
    mode: "display" | "edit";
    editedValue?: Record<string, unknown>;
    onChange?: (editedValue: Record<string, unknown>) => void;
    displayCode?: string;
    displayDescription?: string;
    displayType?: string;
}

export function GeographyRegDataComparisonRow({
    mode,
    editedValue,
    onChange,
    displayCode,
    displayDescription,
    displayType,
}: GeographyRegDataComparisonRowProps) {
    if (mode === "display") {
        const code = (displayCode ?? "").trim();
        const description = (displayDescription ?? "").trim();
        const type = (displayType ?? "").trim();

        if (!type && (!code || !description || code === description)) {
            return <div className="small">{code || description || "—"}</div>;
        }

        return (
            <div className="small">
                <span>{code || "—"}</span>
                <span className="mx-1">|</span>
                <span>{description}</span>
                <span className="mx-1">|</span>
                <span>{type || "—"}</span>
            </div>
        );
    }

    const code = String(editedValue?.code ?? "");
    const description = String(editedValue?.description ?? "");
    const type = String(editedValue?.type ?? "");

    return (
        <Row className="g-2 small">
            <Col md={3}>
                <Form.Group>
                    <Form.Label className="mb-0">Code</Form.Label>
                    <Form.Control
                        size="sm"
                        value={code}
                        onChange={(e) => onChange?.({ ...editedValue, code: e.target.value })}
                    />
                </Form.Group>
            </Col>
            <Col md={5}>
                <Form.Group>
                    <Form.Label className="mb-0">Description</Form.Label>
                    <Form.Control
                        size="sm"
                        value={description}
                        onChange={(e) => onChange?.({ ...editedValue, description: e.target.value })}
                    />
                </Form.Group>
            </Col>
            <Col md={4}>
                <Form.Group>
                    <Form.Label className="mb-0">Type</Form.Label>
                    <Form.Select
                        size="sm"
                        value={type}
                        onChange={(e) => onChange?.({ ...editedValue, type: e.target.value })}
                    >
                        <option value="">Select type…</option>
                        {GEOGRAPHY_TYPE_OPTIONS.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>
    );
}
